import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauStatutAnterieurAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options: BaseLiquidationOptions = null) {
		super(options);
		this.label = 'Remettre sur le statut antérieur';
		this.type = BordereauActionType.STATUT_ANTERIEUR;
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		result: Promise.resolve(bordereau),
		type: ActionResultType.NOTHING,
	});
}

export default BordereauStatutAnterieurAction;
